import { FC } from 'react';

import { StreamingPlatform as StreamingPlatformType } from 'types';
import { notLinkedStreamingPlatformsSelector } from 'store/selectors';
import { useStore } from 'hooks';
import StreamingPlatform from 'containers/StreamingPlatform';

import styles from './AddStreamingPlatformsPanel.module.scss';

export type StreamingPlatformsProps = {
  onClick?: (platform: StreamingPlatformType) => void;
};

const AddStreamingPlatformsPanel: FC<StreamingPlatformsProps> = ({ onClick }): JSX.Element => {
  const platforms = useStore(notLinkedStreamingPlatformsSelector);

  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        {platforms.map(({ key: platformKey }) => (
          <li key={platformKey}>
            <button type="button" className={styles.row} onClick={() => onClick?.(platformKey)}>
              <StreamingPlatform platform={platformKey} action="add" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AddStreamingPlatformsPanel;
